import React, { Component } from 'react';
import { Card, Row, Col } from 'antd';
import { inject, observer } from 'mobx-react';

import MetricWithProgress from './MetricWithProgress';
import Metric from './Metric';
import AirIcon from '../../../../../common/icons/AirIcon';

import './HealtCarCard.css';
import moment from 'moment';
import GraphLineIcon from '../../../../../common/icons/GraphLineIcon';
import BatteryHistory from './BatteryHistory';

@inject('translationsStore', 'commonStore')
@observer
export default class HealtCarCard extends Component {
  constructor(props) {
    super(props);
    this.state = { visibleBatteryHistory: false };
  }

  onShowBatteryHistory = () => {
    this.setState({ visibleBatteryHistory: true });
  };

  render() {
    const { translationsStore, commonStore, ignitionState, ignitionStateUpdatedAt } = this.props;
    return (
      <Card className="HealtCarCard" style={this.props.style}>
        <Row type="flex" className="header">
          <Col>{translationsStore.translate('carView.healtStatus.title')}</Col>
          <div style={{ display: 'flex', alignItems: 'center', fontSize: '0.9rem' }}>
            <Col style={{ textTransform: 'capitalize' }}>{translationsStore.translate(`carView.car.ignitionState.${ignitionState}`)}</Col>
            {ignitionStateUpdatedAt && (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                &nbsp;<Col>{translationsStore.translate(`since`)}</Col>
                &nbsp;<Col>{moment(ignitionStateUpdatedAt).format(commonStore.longDateFormat.L)}</Col>
                &nbsp;<Col>{moment(ignitionStateUpdatedAt).format(commonStore.longDateFormat.LT)}</Col>
              </div>
            )}
          </div>
        </Row>
        <div className="container">
          <div>
            <MetricWithProgress
              name="fuelLevel"
              iconMainColor="#cc0000"
              icon={<AirIcon type="fuel" style={{ fontSize: '16px', lineHeight: '18px' }} />}
              steps={[10, 20, 30]}
              metric={this.props.fuelLevel}
              uom="%"
              translate={this.props.translationsStore.translate.bind(translationsStore)}
              strokeColors={['red', 'orange', 'yellow', 'green']}
              locale={commonStore.dateFnsLocale}
            />
            <MetricWithProgress
              name="coolerTemp"
              iconMainColor="#58e853"
              icon={<AirIcon type="cooling" style={{ fontSize: '16px' }} />}
              steps={[85, 105]}
              upperBound={120}
              lowerBound={0}
              metric={this.props.coolerTemp}
              uom="&#8451;"
              translate={this.props.translationsStore.translate.bind(translationsStore)}
              strokeColors={['blue', 'green', 'red']}
              locale={commonStore.dateFnsLocale}
            />
            <MetricWithProgress
              name="battery"
              iconMainColor="#EE9A0E"
              icon={<AirIcon type="battery-warning" />}
              steps={[9.5, 10]}
              upperBound={15}
              metric={this.props.battery}
              uom="V"
              translate={this.props.translationsStore.translate.bind(translationsStore)}
              strokeColors={['red', 'orange', 'green']}
              locale={commonStore.dateFnsLocale}
            />
          </div>

          <div>
            <Metric
              icon={<AirIcon type="km" style={{ color: '#7acc00' }} />}
              name="odometer"
              metric={this.props.odometer}
              uom="Km"
              translate={this.props.translationsStore.translate.bind(translationsStore)}
              locale={commonStore.dateFnsLocale}
            />
            <Metric
              name="gpsOdometer"
              icon={<AirIcon type="km" style={{ color: 'blue' }} />}
              metric={{ value: (this.props.gpsOdometer || {}).value + this.props.initialOdometer, updatedAt: (this.props.gpsOdometer || {}).updatedAt }}
              uom="Km"
              translate={this.props.translationsStore.translate.bind(translationsStore)}
              locale={commonStore.dateFnsLocale}
            />
            <Metric
              icon={<AirIcon type="oil" style={{ fontSize: '10px' }} />}
              name="oilLevel"
              metric={this.props.oilLevel}
              style={{ visibility: 'hidden' }}
              uom="mm"
              translate={this.props.translationsStore.translate.bind(translationsStore)}
              locale={commonStore.dateFnsLocale}
            />
          </div>
        </div>
      </Card>
    );
  }
}
